(function () {
  const SEL = '.free-bottle-selector select';

  async function fetchProducts() {
    const all = [];
    let page = 1;
    while (true) {
      const res = await fetch('/products.json?limit=250&page=' + page);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const { products } = await res.json();
      if (!products.length) break;
      all.push(...products);
      if (products.length < 250) break;
      page++;
    }
    return all.sort((a, b) => a.title.localeCompare(b.title));
  }

  function fill(select, products) {
    select.innerHTML = '';
    const ph = document.createElement('option');
    ph.value = '';
    ph.disabled = true;
    ph.selected = true;
    ph.textContent = 'Choose From List';
    select.appendChild(ph);
    products.forEach(p => select.appendChild(new Option(p.title, p.title)));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    console.log('[FBS] Filled ' + products.length + ' products');
  }

  function attachGuard(select, products) {
    let busy = false;
    let userHasSelected = false;

    // PFB dispatches 'change' on the native select when the user picks a value.
    // We capture that here so the guard below knows to stop re-filling.
    select.addEventListener('change', function () {
      if (select.value) userHasSelected = true;
    });

    // PFB's change handler may clear the native <select> options as part of
    // its internal re-render.  Re-fill when that happens — but once the user
    // has actually chosen a product, stop interfering so PFB's display label
    // can update correctly and stay updated.
    new MutationObserver(function () {
      if (busy || userHasSelected || select.options.length > 1) return;
      busy = true;
      console.log('[FBS] Re-filling after re-render');
      fill(select, products);
      busy = false;
    }).observe(select, { childList: true });
  }

  async function init() {
    console.log('[FBS] init(), readyState=' + document.readyState);
    let products;
    try {
      products = await fetchProducts();
      console.log('[FBS] Fetched ' + products.length + ' products');
    } catch (e) {
      console.error('[FBS] Fetch failed:', e);
      return;
    }

    function setup(select) {
      fill(select, products);
      attachGuard(select, products);
    }

    const existing = document.querySelector(SEL);
    if (existing) {
      console.log('[FBS] Select found immediately');
      setup(existing);
      return;
    }

    console.log('[FBS] Select not in DOM yet — observing...');
    const obs = new MutationObserver(function () {
      const el = document.querySelector(SEL);
      if (!el) return;
      obs.disconnect();
      console.log('[FBS] Select found via observer');
      setup(el);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
